import { DynamicFilter, DynamicFilterOperator } from "../DynamicFilter";

export class NumericFilter extends DynamicFilter {
  public disabledOperators: DynamicFilterOperator[] = [
    "contains",
    "notContains",
    "in",
    "notIn",
  ];
}
